import {
  TMeetingInfo,
  TSpeakerContent,
} from "../../../services/api/instances/meetingsApi/types";

export const generateFinalResultText = (
  meetingInfo: TMeetingInfo,
  transcription: TSpeakerContent[]
): string => {
  const { meeting_name, meeting_date, meeting_description } = meetingInfo;

  let formattedDate = "";
  if (meeting_date) {
    const date = new Date(meeting_date);
    const day = date.getDate();
    const month = date.toLocaleString("ru-RU", { month: "long" });
    const year = date.getFullYear();
    formattedDate = `${day} ${month} ${year} г.`;
  }

  const headerLines = [
    meeting_name ? `Название встречи: ${meeting_name}` : "Название встречи: ",
    meeting_date ? `Дата: ${formattedDate}` : "Дата: ",
    meeting_description ? `Описание: ${meeting_description}` : "Описание: ",
  ];

  const transcriptionLines = transcription.map(
    (item) => `${item.speaker_name}: ${item.speech_content}`
  );

  return [...headerLines, "", ...transcriptionLines].join("\n");
};
